<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Julia Crothers was born and raised in Cardiff, South Wales, where she currently lives with her husband and five children. Having worked with children for most of her adult life, she has now turned her attention to writing. Her current novel, ‘Scarred’, follows on from the success of her first novel, ‘Solari’, which was published in 2016.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c8d19de6